<div>
  <div class="card-header">
    <div class="title-section">
      <h2 class="header-title" *ngIf="data && !config">Sucursales</h2>
    </div>
    <div class="button-section">
      <div class="p-input-icon-left search-input">
        <i class="pi pi-search"></i>
        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Buscar..." appPermissionControl="P104K0001" />
      </div>
      <p-dropdown
        [options]="empresas"
        [(ngModel)]="empresaSeleccionada"
        optionLabel="label"
        placeholder="Seleccione una empresa"
        [showClear]="true"
        appendTo="body"
        (onChange)="onEmpresaChange()"
        styleClass="w-100"
        appPermissionControl="P104K0002">
      </p-dropdown>
      <button mat-flat-button class="btn-new" (click)="nuevo()" appPermissionControl="P104B0001">
        <mat-icon>add</mat-icon>
        Nuevo
      </button>
      <button mat-flat-button (click)="Close()" class="btn-delete" *ngIf="data && !config">
        <mat-icon>close</mat-icon>
        Cerrar
      </button>
    </div>
  </div>

  <p-table
    #dt
    [value]="dataSource"
    [columns]="columns"
    [paginator]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 15, 20]"
    [scrollable]="true"
    scrollHeight="400px"
    styleClass="p-datatable-gridlines"
    [resizableColumns]="true"
    [autoLayout]="true"
    responsiveLayout="scroll"
    [loading]="loading"
    [globalFilterFields]="['ssucursal', 'nombre_sucursal', 'ciudad']"
    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
    appPermissionControl="P104T0001"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field !== 'actions' ? col.field : null" class="th-prime" appPermissionControl="P104C0001">
          {{ col.header }}
          <p-sortIcon *ngIf="col.field !== 'actions'" [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" class="td-prime">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchCase="'actions'">
              <div class="d-flex align-items-center justify-content-center gap-2">
                <button pButton icon="pi pi-eye" class="p-button-rounded p-button-info p-button-text" (click)="ver(rowData)" pTooltip="Editar" appPermissionControl="P104B0002"></button>
                <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" (click)="delete(rowData)" pTooltip="Eliminar" appPermissionControl="P104B0003"></button>
              </div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ rowData[col.field] }}
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns.length" class="text-center td-prime">No hay datos para mostrar</td>
      </tr>
    </ng-template>
  </p-table>
</div>
